import styled from 'styled-components';

const CenteredRowDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default CenteredRowDiv;
